import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-expbar',
  templateUrl: './expbar.component.html',
  styleUrls: ['./expbar.component.scss']
})
export class ExpbarComponent implements OnInit {
  private destroy$ = new Subject();
  public user$: Observable<any>|undefined;
  public levels$: Observable<any>|undefined;
  user:any='';
  nextExp:number = 0;
  expNeeded:number = 0;
  currentLevel:number=0;
  nextLevel:number=0;
  constructor(private mainfacade:MainFacade, private sanitizer: DomSanitizer, private toastService: ToastService, private router:Router) { 

    
  }

 

 
  ngOnInit(): void {
    
    this.createSubscriptions();
  }




  ngOnDestroy() {
    this.destroy$.next(true);
  }

  
  createSubscriptions(){
    this.user$ = this.mainfacade.user$;
   
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.user = message;
        }
    });

    this.levels$ = this.mainfacade.levels$;
    this.levels$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 

      if(message){
        let levelFound = false;
        if(this.user){
          let gang = this.user.UserSkills.find(element => {
            
            return element.SkillName === 'Gang Level';
          });
          message.forEach(element => {
            if(Number(gang.Exp) >= Number(element.Exp)){
              this.currentLevel = element.Level;
            }
            else {
              if(!levelFound){
                levelFound=true;
                this.nextExp=Number(element.Exp);
                this.nextLevel = element.LevelName;
              }
        
            }
            
          });
  
          this.expNeeded = this.nextExp -  Number(gang.Exp);
        }
        
      }

    });

  }
}
